import { combineReducers } from 'redux';
import { reducerGeneral } from './reducerGeneral';
import { reducerToolkit } from './reducerToolkit';

const reducers = combineReducers({
    general: reducerGeneral,
    toolkit: reducerToolkit
});

export default reducers;